import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Injectable } from '@angular/core';
import { ApiActiveService } from "../api/api-active.service";
import { FilterOptions } from "@shared/interfaces/filterOptions.interface";
import { AuthService } from "@data/services/modules/auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class ActiveService {
  entity!: FormGroup
  formMethod = 'CREATE'
  active: any
  providers: { label: string; value: string; }[] = []
  user: string = ''

  constructor(
    private fb: FormBuilder,
    private apiActiveService: ApiActiveService,
  ) {
    this.fetchProviders({ page: 1, limit: 1000, filters: {} });
  }

  fetchProviders(filterOptions: FilterOptions): void {
    filterOptions.limit = 1000;

    this.apiActiveService.fetchProviders(filterOptions).subscribe(
      (response) => {
        this.providers = response;
      },
      (error) => {
        console.error('Error al obtener los proveedores', error);
      }
    );
  }

  nonNegativeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value < 0) return { negativeValue: 'El valor no puede ser negativo' };

    return null;
  }

  onlyLettersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const valid = /^[a-zA-Z\s]*$/.test(value);
    if (!valid) return { onlyLetters: 'Solo se permiten letras' };

    return null;
  }

  getProviderName(id: string) {
    return this.providers.find(provider => provider.value === id)?.label;
  }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        this.entity = this.fb.group({
          banker: [this.user],
          provider: [''],
          name: ['', [Validators.required, Validators.minLength(3)]],
          category: ['', [Validators.required]],
          brand: ['', [Validators.required]],
          assetModel: ['', [Validators.required]],
          serie: ['', [Validators.required]],
          version: ['', [Validators.required]],
          color: ['', [Validators.required, this.onlyLettersValidator]],
          engineNumber: [''],
          description: ['', [Validators.required]],
          acquisition: this.fb.group({
            amount: [''],
            iva: [''],
            total: ['', [Validators.required, this.nonNegativeValidator]],
          }),
          status: ['Activo'],
          isPublic: [false],
        });
        break;
      case 'EDIT':
        this.entity = this.fb.group({
          banker: [this.active.banker || ''],
          provider: [this.active.provider],
          name: [this.active.name, [Validators.required, Validators.minLength(3)]],
          category: [this.active.category, [Validators.required]],
          brand: [this.active.brand, [Validators.required]],
          assetModel: [this.active.assetModel, [Validators.required]],
          serie: [this.active.serie, [Validators.required]],
          version: [this.active.version, [Validators.required]],
          color: [this.active.color, [Validators.required, this.onlyLettersValidator]],
          engineNumber: [this.active.engineNumber || 'N/A'],
          description: [this.active.description, [Validators.required]],
          acquisition: this.fb.group({
            amount: [this.active.acquisition.amount],
            iva: [this.active.acquisition.iva],
            total: [this.active.acquisition.total, [Validators.required, this.nonNegativeValidator]],
          }),
          status: [this.active.status],
          isPublic: [this.active.isPublic || false],
        });
        break;
    }
  }
}
